import React from 'react';
import { createRoot } from 'react-dom/client';

interface AskConfirmationOptions {
  body: string;
  confirmText?: string;
  title?: string;
}

/**
 * Pop up a confirmation modal. Returns true or false once the user makes a
 * selection. This function must be used with `await`.
 */
export default async function askConfirmation({
  body,
  confirmText,
  title,
}: AskConfirmationOptions): Promise<boolean> {
  return new Promise(resolve => {
    var dialogContainer = document.createElement('div');
    document.body.appendChild(dialogContainer);
    const root = createRoot(dialogContainer);

    const completeFunc = (result: boolean) => {
      root.unmount();
      dialogContainer.remove();
      resolve(result);
    };

    root.render(
      <aha-modal id='confirmation_dialog' size='small' open>
        <aha-modal-header warning>{title || 'Warning'}</aha-modal-header>
        <aha-modal-body-danger>
          <div slot='content'>{body}</div>
        </aha-modal-body-danger>
        <aha-modal-footer>
          <aha-button
            onClick={() => {
              completeFunc(false);
            }}
          >
            Cancel
          </aha-button>
          <aha-button
            kind='danger'
            onClick={() => {
              completeFunc(true);
            }}
          >
            {confirmText || 'Yes'}
          </aha-button>
        </aha-modal-footer>
      </aha-modal>
    );
  });
}
